export const SET_COMMON_LOADING = 'SET_COMMON_LOADING'
export const SET_CATEGORIES = 'SET_CATEGORIES'
export const SET_POSTS = 'SET_POSTS'
export const RESET_POSTS = 'RESET_POSTS'

